import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getUser } from "./session";
import { homePathForRole } from "./homePath";

/**
 * Role gate for office routes. Backend still enforces permissions;
 * this hides admin shells from roles that must never open them.
 */
export function RequireRole({
  roles,
  children,
}: {
  roles: string[];
  children: ReactNode;
}) {
  const user = getUser();
  const role = user?.role;
  if (!role || !roles.includes(role)) {
    return <Navigate to={homePathForRole(role)} replace />;
  }
  return <>{children}</>;
}
